import React from 'react';
import Link from 'next/link';

const LegalFooter = () => {
  return (
    <div className="bg-navy-2 py-2.5 text-center">
      <div className="md:mx-auto md:my-0 md:flex md:max-w-[615px] md:justify-around">
        <p className="font-source-sans text-[12px] leading-[1.42] text-grey-3">
          &copy; 1998-{new Date().getFullYear()} CMH Services, Inc. All rights
          reserved.
        </p>
        <p className="font-source-sans text-[12px] leading-[1.42] text-grey-1 md:ml-[5px]">
          <Link
            target="_blank"
            rel="noopener"
            href="https://www.claytonhomes.com/legal"
            className="border-r border-navy-3 pr-2.5 font-source-sans text-[12px] leading-[1.42] text-grey-3 no-underline hover:text-white"
          >
            Legal
          </Link>
          <Link
            target="_blank"
            rel="noopener"
            href="https://www.claytonhomes.com/privacy"
            className="border-r border-navy-3 px-2.5 font-source-sans text-[12px] leading-[1.42] text-grey-3 no-underline hover:text-white"
          >
            Privacy
          </Link>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              (window as any).Osano.cm.showDrawer(
                'osano-cm-dom-info-dialog-open'
              );
            }}
            scroll={false}
            className="pl-2.5 pr-0 font-source-sans text-[12px] leading-[1.42] text-grey-3 no-underline hover:text-white"
          >
            Do Not Sell or Share My Personal Information
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LegalFooter;
